import React, { Component } from 'react'

// Utils
import { formatCurrency2 } from '../../../utils/currency'
import { translation } from '../../../utils/helpers'

// Elements
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'
import Text from '../../../shared/elements/text'

class PriceCalculationType extends Component {
  render () {
    let item = this.props.item
    if (!item) return null

    // const onBlur = () => {
    //   let { price } = this.state
    //   price.PriceHourly = reverseFormatCurrency2(price.PriceHourly)

    //   this.props.updatePriceList(price).then(res => {
    //     this.setState({ price: res.data })
    //     // Toastr
    //     // window.toastr.success(translation('15157'), translation('13424'))
    //   }, () => {
    //     // Toastr
    //     window.toastr.error(translation('13445'), translation('216'))
    //   })
    // }

    // Return
    return (
      <Panel title={translation('18314')}>
        <Text
          name='PriceHourly'
          value={formatCurrency2(item.PriceHourly)}
          onChange={this.props.onChange}
          onBlur={this.props.onBlur}
          disabled={item.IsDisabled}
          labelText={translation('419')}
        />

        <LabelWrapper labelText={translation('1256')}>
          <Radio name='PriceCalculationType' value='0' onChange={e => this.props.onChange(e, true)} disabled={item.IsDisabled} checked={item.PriceCalculationType === 0} labelText={translation('12273')} helpText={translation('12274')} />
          <Radio name='PriceCalculationType' value='1' onChange={e => this.props.onChange(e, true)} disabled={item.IsDisabled} checked={item.PriceCalculationType === 1} labelText={translation('12275')} helpText={translation('12276')} />
          <Radio name='PriceCalculationType' value='2' onChange={e => this.props.onChange(e, true)} disabled={item.IsDisabled} checked={item.PriceCalculationType === 2} labelText={translation('12277')} helpText={translation('12278')} />
        </LabelWrapper>
      </Panel>
    )
  }
}

export default PriceCalculationType



// WEBPACK FOOTER //
// ./src/app/pages/Prices/Discounts/PriceCalculationType.js